import React from 'react';
import { Heading } from '@chakra-ui/react';

const PageHeader = ({ title }) => {
  return (
    <Heading as="h1" size="lg" mb="5" noOfLines={1} mt="20px">
      {title}
    </Heading>
  );
};

export default PageHeader;
